import { createAnalyticsColumnHeader } from './createAnalyticsColumnHeader';
import { INVOICE_COLUMN_NAME_MAP } from './constants/invoiceColumnConfig';
import type { AnalyticsColumnHeaderProps } from './createAnalyticsColumnHeader';

/**
 * Invoice column header component
 * Generated using shared factory to eliminate code duplication
 */
export const InvoiceColumnHeader: React.FC<AnalyticsColumnHeaderProps> = createAnalyticsColumnHeader({
  tableType: 'INVOICES',
  columnNameMap: INVOICE_COLUMN_NAME_MAP,
});
